import Head from 'next/head';
import { PropsWithChildren } from 'react';

type AnalyticsProps = PropsWithChildren & {
  pageTitle?: string;
};

function Analytics({ pageTitle, children }: AnalyticsProps) {
  return (
    <Head>
      {pageTitle && <title>{pageTitle}</title>}

      {children}
    </Head>
  );
}

export default Analytics;
